module.exports = __webpack_public_path__ + "static/media/logo-humbertocampos.299f6fe9.png";